import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { ProfileForm } from 'components/blocks/profile';
import ProfileDetailScreen from './ProfileDetailScreen';


class ProfileScreen extends Component {
    state = {
        id: null,
    };

    componentDidMount() {
        const { actions, match } = this.props;
        actions.profileDetailLoad({ id: match.params.id });
        this.setState({ id: match.params.id });
    }

    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.profileShowEditForm({ show: true, object: item });
    };

    delete = () => {
        const { actions } = this.props;
        const { id } = this.state;
        actions.profileDelete({ id });
    };

    render() {
        const { profile, history } = this.props;
        const detail = profile.detail || {};

        return (
            <Page>
                <PageHeader
                    history={history}
                    title={detail.name_en}
                    actions={[
                        <Button onClick={() => this.showEditForm(detail)}>
                            <Icon type="edit"/>
                            <span>Редактировать</span>
                        </Button>,
                        <ActionButton
                            actions={[
                                {
                                    key: 'delete',
                                    icon: <Icon type="delete"/>,
                                    title: 'Удалить',
                                    action: this.delete,
                                    confirm: {
                                        title: 'Уверены, что хотите удалить?',
                                        okText: 'Удалить',
                                        cancelText: 'Отмена'
                                    }
                                },
                            ]}

                        />
                    ]}
                    basePath={`/profile/${this.state.id}`}
                />

                <Route exact path="/profile/:id" component={ProfileDetailScreen}/>

                <ProfileForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        profile: state.profile,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.profile), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfileScreen);
